// src/api/premiumService.ts
import apiClient from './config';

export type ToolKey =
  | 'leaked_data' | 'emails' | 'ips' | 'ipwhois' | 'subdomains'
  | 'typosquatting' | 'names_tld' | 'whois' | 'dns_all_records' | 'wafw00f'
  | 'wappalyzer' | 'gau' | 'spoofornot' | 'screenshot';

export interface PremiumUsageItem { key: ToolKey; count: number; }

export interface PremiumQuotas {
  leaked_data: number; emails: number; employees: number; ips: number; ipwhois: number;
  subdomains: number; typosquatting: number; names_tld: number; whois: number;
  dns_all_records: number; wafw00f: number; wappalyzer: number; gau: number;
  spoofornot: number; screenshot: number;
}

export interface PremiumHistoryItem {
  id: string;
  tool: ToolKey;
  created_at: string;
  input?: Record<string, unknown>;
}

export interface PremiumWindow {
  starts_at: string; ends_at: string; days_left: number;
}
export interface PremiumMeResponse {
  is_premium: boolean;
  premium: PremiumWindow;
  quotas: PremiumQuotas;
  usage: PremiumUsageItem[];
  history: PremiumHistoryItem[];
}

export interface ExecutePayload {
  tool: ToolKey;
  [k: string]: any;
}

export interface ExecuteResponse {
  tool: ToolKey;
  ok: boolean;
  data?: any;
  error?: string;
  remaining_quota?: number;
}

export const getPremiumMe = async (): Promise<PremiumMeResponse> => {
  const { data } = await apiClient.get<PremiumMeResponse>('/premium/me');
  return data;
};

export interface JobStartResponse { job_id: string; remaining_quota: number; }
export type JobStatus = 'queued'|'running'|'done'|'error';
export interface JobStateResponse { job_id: string; status: JobStatus; payload?: any; }

export async function startExecuteTool(payload: ExecutePayload): Promise<JobStartResponse> {
  const { data } = await apiClient.post<JobStartResponse>('/premium/execute-tool', payload, { timeout: 0 });
  return data;
}

export async function getExecuteJob(jobId: string): Promise<JobStateResponse> {
  const { data } = await apiClient.get<JobStateResponse>(`/premium/execute-tool/${jobId}`, { timeout: 30000 });
  return data;
}